<ng-container *ngIf="!!get">
    <!-- <tt-page-heading> {{ get.folder_heading }}</tt-page-heading> -->
    <tt-card class="col-xs-12 sp-5" [ttHeading]="get.folder_heading" ttTranslateHeading="false" [ttIcon]="get.item_type_selected === 'project_keyno' ? 'far fa-home' : 'far fa-folder'">
        <tt-tabs ttRememberId="w_projectfolders.tab_projectfolders" [(ttSelectedId)]="get.tab_projectfolders" (ttSelectedIdChange)="onTabSelected()">
            <tt-tab *ngIf="get.show_tab_documents === '1'" ttId="DOCUMENTS" ttIcon="far fa-file-alt" ttLabel="projectfolders_documents"></tt-tab>
            <tt-tab *ngIf="get.show_tab_powtimes === '1'" ttId="POWTIMES" ttIcon="far fa-clock" ttLabel="projectfolders_powtimes"></tt-tab>
            <tt-tab *ngIf="get.show_tab_checklists === '1'" ttId="CHECKLISTS" ttIcon="far fa-clipboard-list-check" ttLabel="projectfolders_checklists"></tt-tab>
            <tt-tab *ngIf="get.show_tab_custacts === '1'" ttId="CUSTACTS" ttIcon="far fa-tasks" ttLabel="projectfolders_custacts"></tt-tab>
            <tt-tab *ngIf="get.show_tab_projectprosesses === '1'" ttId="PROJECTPROSESSES" ttIcon="far fa-folder" ttLabel="projectfolders_projectprosesses"></tt-tab>
        </tt-tabs>
        <div *ngIf="get.show_tab_projectprosesses === '1'" [hidden]="get.tab_projectfolders !== 'PROJECTPROSESSES'">
            <tt-button
                class="col-xs-12 col-md-4 sp-5"
                *ngIf="get.show_button_edit_projectprosess === '1'"
                ttText="edit_projectprosess"
                ttIcon="fas fa-pencil"
                (ttClick)="openEditProjectProcess()"
            ></tt-button>
            <tt-button
                class="col-xs-12 col-md-4 sp-5"
                *ngIf="get.show_button_create_new_projectprosess === '1'"
                ttText="create_new_projectprosess"
                ttIcon="fas fa-plus"
                (ttClick)="openNewProjectProcess()"
            ></tt-button>
            <tt-button
                class="col-xs-12 col-md-4 sp-5"
                *ngIf="get.show_button_delete_projectprosess === '1'"
                ttText="delete"
                ttIcon="fas fa-trash"
                (ttClick)="deleteProjectProsess()"
                [ttLoading]="deleting"
                ttType="danger"
            >
            </tt-button>
        </div>
    </tt-card>

    <tt-card *ngIf="get.show_button_copy_from_template === '1'" ttHeading="copy_from_project_template" class="col-xs-12 col-md-4 p-5">
        <tt-search
            ttLabel="project_keyno"
            [(ttModel)]="get.copy_from_project_name"
            [ttSearch]="searchProjectTemplates"
            ttDataId="project_keyno"
            ttDataName="project_name"
            ttMinLength="0"
            (ttOnSelected)="onProjectSelected($event)"
            (ttOnClear)="onProjectSelected()"
        ></tt-search>

        <tt-button-save ttText="projectfolders_copy_save" (ttClick)="copy()" [ttLoading]="copying" [ttDisabled]="get.copy_from_project_keyno <= '0'"></tt-button-save>
        <!-- <tt-button ttText="copy_from_project_template" (ttClick)="selectCopyFromProject()" [ttDisabled]="!selectedProject"></tt-button> -->
    </tt-card>

    <tt-documents-grid
        *ngIf="get.show_tab_documents === '1'"
        [hidden]="get.tab_projectfolders !== 'DOCUMENTS'"
        [params]="{ argtype: this.get.item_type_selected, argvalue: this.get.item_id_selected.replaceAll('P', ''), searchtext: '', doctype: 'd', onlyFilenames: '0', webpage_name: 'projectfolder' }"
        (gridReady)="documentsGrid = $event"
    ></tt-documents-grid>

    <!-- <tt-grid [hidden]="get.tab_projectfolders !== 'POWTIMES'" *ngIf="!!powtimesGrid && get.show_tab_powtimes === '1'" class="height-full flex-1" [(ttOptions)]="powtimesGrid"></tt-grid> -->
    <tt-powtimes-grid
        *ngIf="get.show_tab_powtimes === '1' && powtimesGridReady"
        [hidden]="get.tab_projectfolders !== 'POWTIMES'"
        [params]="{
            webpage_name: 'projectmenu',
            businessco_no: '99999',
            show_setting: '1',
            argtype: this.get.item_type_selected,
            argvalue: this.get.item_id_selected.replaceAll('P', ''),
            date_fom: '1901-01-01',
            date_tom: '2999-12-31',
            dateselector_index: '8',
            view_id: 'w_powtimes.grid',
            date_fomtom: '1901-01-012999-12-31',
            labour_no: '0',
            cust_no: '0',
            cust_name: '',
            project_keyno: '0',
            project_name: '',
        }"
        (gridReady)="powtimesGrid = $event"
    ></tt-powtimes-grid>

    <tt-grid [hidden]="get.tab_projectfolders !== 'CHECKLISTS'" *ngIf="!!checklistsGrid && get.show_tab_checklists === '1'" class="height-full flex-1" [(ttOptions)]="checklistsGrid"></tt-grid>

    <tt-grid [hidden]="get.tab_projectfolders !== 'CUSTACTS'" *ngIf="!!custactsGrid && get.show_tab_custacts === '1'" class="height-full flex-1" [(ttOptions)]="custactsGrid"></tt-grid>

    <div *ngIf="get.show_tab_projectprosesses === '1'" [hidden]="get.tab_projectfolders !== 'PROJECTPROSESSES'" style="display: flex; flex-direction: column; width: 100%; height: 100%; flex: 1">
        <!-- <tt-card class="col-xs-12 p-5">
            <tt-button
                class="col-xs-12 col-md-4 sp-5"
                *ngIf="get.show_button_edit_projectprosess === '1'"
                ttText="edit_projectprosess"
                ttIcon="fas fa-pencil"
                (ttClick)="openEditProjectProcess()"
            ></tt-button>
            <tt-button
                class="col-xs-12 col-md-4 sp-5"
                *ngIf="get.show_button_create_new_projectprosess === '1'"
                ttText="create_new_projectprosess"
                ttIcon="fas fa-plus"
                (ttClick)="openNewProjectProcess()"
            ></tt-button>
            <tt-button
                class="col-xs-12 col-md-4 sp-5"
                *ngIf="get.show_button_delete_projectprosess === '1'"
                ttText="delete"
                ttIcon="fas fa-trash"
                (ttClick)="deleteProjectProsess()"
                [ttLoading]="deleting"
                ttType="danger"
            >
            </tt-button>
        </tt-card> -->

        <tt-grid *ngIf="!!projectProcessesGrid && get.item_type_selected === 'project_keyno'" style="display: block; height: 100%; flex: 1" [(ttOptions)]="projectProcessesGrid"></tt-grid>
    </div>
</ng-container>
<!-- 
<p>project-folder works!</p>
<span *ngIf="!!get">
    {{ get | json }}
</span> -->
